module.exports = __webpack_public_path__ + "static/media/ic_searchtype_destination.02262f48.svg";